module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAALBAMAAABrDns0AAAAIGNIUk0AAHomAACAhAAA+gAAAIDoAAB1MAAA6mAAADqYAAAXcJy6UTwAAAAeUExURa8bJ7AeKqoNGclnb/////r5+muEshM6hSRJjiFGjOc9vcIAAAABYktHRASPaNlRAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH5wMXCw03TL2gzwAAADRJREFUCNdjYIADQSgQYFCCAgUGYygwYHCBAgeGUCgIQBJLg4IEhnIoKGDogIIGhplQMAEAE3YdGQc9tXMAAAAldEVYdGRhdGU6Y3JlYXRlADIwMjMtMDMtMjNUMTE6MTM6MjcrMDA6MDCG5AztAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDIzLTAzLTIzVDExOjEzOjI3KzAwOjAw97m0UQAAACh0RVh0ZGF0ZTp0aW1lc3RhbXAAMjAyMy0wMy0yM1QxMToxMzo1NSswMDowMD32jb4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/nl.png
// module id = 1280
// module chunks = 0